import axios from "axios";
import { authHeader } from "../authservice/auth-header";

const API_URL =process.env.VUE_APP_ROOT_API
class InboxService {
  //  SMS RELATED  APIs

  // Get Tags
  getTagsOfGroup() {
    return axios
      .get(API_URL + "msg/group-tag", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // add tags
  addTagsOfGroup(data) {
    return axios
      .post(API_URL + "msg/group-tag", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Edit tags
  editTagsOfGroup(id, data) {
    return axios
      .patch(API_URL + "msg/group-tag/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get all inbox groups
  getInboxGroups(filter = "") {
    return axios
      .get(API_URL + "msg/inbox-group" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add new inbox group
  addInboxGroups(data) {
    return axios
      .post(API_URL + "msg/inbox-group", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add new inbox user group
  addInboxGuestGroups(data) {
    return axios
      .post(API_URL + "msg/text-msg-send", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Edit user group
  editInboxGroups(id, data) {
    return axios
      .patch(API_URL + "msg/inbox-group/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get a users to tags
  getAllSMSUsers() {
    return axios
      .get(API_URL + "msg/user", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get list of messages by group id
  getInboxChatGroup(group_id) {
    return axios
      .get(API_URL + "msg/inbox-group/" + group_id + "/message", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // To send message
  chatMessages(id, data) {
    return axios
      .post(API_URL + "msg/inbox-group/" + id + "/message", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // React to a messsage
  addReaction(message_id, data) {
    return axios
      .patch(API_URL + "msg/inbox-message/" + message_id + "/reaction", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // To follow a group
  followInboxGroup(id) {
    return axios
      .post(
        API_URL + "msg/inbox-group/" + id + "/followers/add",
        {},
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // To unfollow a group
  unfollowInboxGroup(id) {
    return axios
      .post(
        API_URL + "msg/inbox-group/" + id + "/followers/remove",
        {},
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // To Mark as Unread
  markAsUnread(msg_id) {
    return axios
      .patch(
        API_URL + "msg/inbox-message/" + msg_id + "/unread",
        {},
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Get list of personal messages by id
  getPersonalChatMessages(id) {
    return axios
      .get(API_URL + "msg/user-message/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // To send message in personal
  personalChatMessages(id, data) {
    return axios
      .post(API_URL + "msg/user-message/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // React to a messsage
  addReactionPersonal(message_id, data) {
    return axios
      .patch(API_URL + "msg/user-message/" + message_id + "/reaction", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // get booking vise sms
  getSMSListByBooking(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/sms-message", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get single user sms and info by guest id id
  getSingleGuestSMS(guest_id) {
    return axios
      .get(API_URL + "guest/" + guest_id + "/sms-message", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // send new SMS booking vise sms
  sendSMS(data) {
    return axios
      .post(API_URL + "send-sms-message", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update SMS Read Status booking vise sms
  updateSMSReadStatus(message_id, data) {
    return axios
      .patch(API_URL + "sms-message/" + message_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new InboxService();
